import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m6.627 11.743-1.18 1.147a1.65 1.65 0 1 1-2.333-2.333L6.14 7.523a1.64 1.64 0 0 1 2.26-.06l.08.067a.667.667 0 0 0 .933-.953 2 2 0 0 0-.12-.14 2.973 2.973 0 0 0-4.06.146L2.167 9.617a2.987 2.987 0 0 0 4.22 4.22l1.154-1.127a.667.667 0 0 0-.914-.967m7.127-9.493a2.993 2.993 0 0 0-4.22 0L8.38 3.377a.667.667 0 0 0 .914.966l1.153-1.146a1.65 1.65 0 1 1 2.334 2.333L9.753 8.563a1.64 1.64 0 0 1-2.26.06l-.08-.066a.667.667 0 1 0-.933.953q.073.075.153.14a2.98 2.98 0 0 0 4.06-.147l3.033-3.033a2.993 2.993 0 0 0 .027-4.22"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })